export default {
  "privacy": {
    "heroTitle": "Política de Privacidad",
    "lastUpdated": "Última actualización: 3 de agosto de 2026",
    "sections": [
      {
        "title": "1. Introducción",
        "paragraphs": [
          "IS TELECOM (en adelante « nosotros », « nuestro » o « IS TELECOM ») se compromete a proteger la privacidad y los datos personales de sus usuarios, clientes y socios. Esta Política de Privacidad explica cómo recopilamos, utilizamos, almacenamos y protegemos sus datos personales cuando utiliza nuestro sitio web is-telecom.co (en adelante « el Sitio ») o cuando interactúa con nosotros.",
          "Al utilizar el Sitio o proporcionarnos sus datos personales, usted acepta las prácticas descritas en esta Política de Privacidad. Si no acepta esta política, por favor no utilice el Sitio."
        ]
      },
      {
        "title": "2. Responsable del Tratamiento",
        "paragraphs": [
          "El responsable del tratamiento de los datos personales recopilados a través del Sitio es IS TELECOM, ubicada en Cotonú, Benín.",
          "Teléfono: +229 01 95 89 27 55 — Email: contact@is-telecom.co"
        ]
      },
      {
        "title": "3. Datos Recopilados",
        "paragraphs": ["Recopilamos las siguientes categorías de datos personales:"],
        "list": [
          "Datos de identificación: nombre, apellido, nombre de la empresa",
          "Datos de contacto: dirección de email, número de teléfono, dirección postal",
          "Datos del proyecto: tipo de proyecto, ubicación, presupuesto estimado, descripción de necesidades",
          "Datos de navegación: dirección IP, tipo de navegador, páginas visitadas, duración de la visita"
        ]
      },
      {
        "title": "4. Finalidades del Tratamiento",
        "paragraphs": ["Sus datos personales son recopilados y tratados para las siguientes finalidades:"],
        "list": [
          "Respuesta a solicitudes: tratar sus solicitudes de presupuesto, contacto e información",
          "Gestión de la relación con el cliente: seguimiento de proyectos, elaboración de presupuestos, gestión de contratos",
          "Comunicación: informarle sobre nuestros servicios, novedades y ofertas (con su consentimiento)",
          "Mejora del Sitio: analizar el uso del Sitio para mejorar el contenido y la navegación",
          "Obligaciones legales: cumplir con nuestras obligaciones legales, reglamentarias y fiscales"
        ]
      },
      {
        "title": "5. Base Legal del Tratamiento",
        "paragraphs": ["El tratamiento de sus datos personales se basa en una de las siguientes bases jurídicas:"],
        "list": [
          "Ejecución de un contrato: cuando el tratamiento es necesario para la ejecución de un contrato",
          "Consentimiento: cuando usted ha dado su consentimiento explícito",
          "Interés legítimo: cuando el tratamiento es necesario para los intereses legítimos de IS TELECOM",
          "Obligación legal: cuando el tratamiento es necesario para cumplir con una obligación legal"
        ]
      },
      {
        "title": "6. Período de Conservación",
        "paragraphs": ["Sus datos personales se conservan durante el período estrictamente necesario:"],
        "list": [
          "Solicitudes de contacto/presupuesto: 3 años desde el último contacto",
          "Datos de clientes y contratos: 10 años desde el fin del contrato",
          "Newsletter y marketing: hasta que retire su consentimiento",
          "Datos de navegación (cookies): máximo 13 meses"
        ]
      },
      {
        "title": "7. Compartición de Datos",
        "paragraphs": [
          "IS TELECOM no vende ni alquila sus datos personales a terceros. Sin embargo, sus datos pueden ser compartidos con proveedores de servicios (alojamiento web, herramientas de análisis, servicios de mensajería), autoridades competentes cuando la ley lo exija, o socios comerciales solo con su consentimiento previo."
        ]
      },
      {
        "title": "8. Seguridad de los Datos",
        "paragraphs": [
          "IS TELECOM implementa medidas técnicas y organizativas apropiadas para proteger sus datos personales: cifrado de datos en tránsito (HTTPS/TLS), acceso restringido según roles, formación de empleados, monitoreo y auditoría regulares."
        ]
      },
      {
        "title": "9. Sus Derechos",
        "paragraphs": [
          "De conformidad con la legislación aplicable, usted dispone de los siguientes derechos: derecho de acceso, derecho de rectificación, derecho de supresión, derecho a la limitación, derecho de oposición, derecho a la portabilidad de datos."
        ]
      },
      {
        "title": "10. Cookies y Tecnologías Similares",
        "paragraphs": [
          "El Sitio utiliza cookies esenciales, de rendimiento, de funcionalidad y de segmentación. Puede gestionar sus preferencias a través de la configuración de su navegador."
        ]
      },
      {
        "title": "11. Transferencias Internacionales",
        "paragraphs": [
          "IS TELECOM está presente en 6 países africanos. Sus datos pueden ser transferidos y tratados en países distintos al de su residencia, con garantías apropiadas para proteger sus datos."
        ]
      },
      {
        "title": "12. Modificaciones de la Política",
        "paragraphs": [
          "IS TELECOM se reserva el derecho de modificar esta Política de Privacidad en cualquier momento. Cualquier modificación será publicada en esta página con la fecha de actualización."
        ]
      },
      {
        "title": "13. Contacto",
        "paragraphs": [
          "Para cualquier pregunta sobre esta Política de Privacidad o para ejercer sus derechos, contáctenos: IS TELECOM — Delegado de Protección de Datos, Cotonú, Benín. Teléfono: +229 01 95 89 27 55. Email: contact@is-telecom.co"
        ]
      }
    ]
  }
};